import { Controller } from '@hotwired/stimulus'
import SmoothScroll from 'smooth-scroll'
import { setupAnchorScroll, teardownAnchorScroll } from '../../../experiences_anchor_scroll'

export default class extends Controller {
  initialize () {
    // 動作実績のある summary/*/component_controller.js と同一設定。
    // offset: 55 はヘッダや固定UIの高さ分のバッファ、speed は速度(ms)。
    this.scroll = new SmoothScroll(null, {
      offset: 55,
      speed: 600,
      speedAsDuration: true,
      easing: 'linear',
      updateURL: false,
      popstate: false,
    })
  }

  connect () {
    setupAnchorScroll(this)
  }

  disconnect () {
    teardownAnchorScroll(this)
  }
}
